import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import {
    Table,
    Card,
    CardBody,
} from 'reactstrap';

import SortableThead from '../../../common/views/SortableThead';
import UserListItem from './UserListItem';

import { userApi, selectAllUsers, setSorting } from '../../reducers/userSlice';


const UsersList = () => {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const sorting = useSelector((state) => state.userReducer.sorting);
    const [firstNameSort, setFirstNameSort] = useState(sorting.first_name);
    const [lastNameSort, setLastNameSort] = useState(sorting.last_name);
    const [emailSort, setEmailSort] = useState(sorting.email);

    const term = useSelector((state) => state.userReducer.term);
    const users = useSelector((state) => selectAllUsers(state));
    const showMoreUsers = useSelector((state) => state.userReducer.showMoreUsers );

    const dispatch = useDispatch();
  
    const loadMoreUsers = (p) => {
        if(!loading) {
            setLoading(true);

            let newSorting = {
                first_name: firstNameSort,
                last_name: lastNameSort,
                email: emailSort
            }
            dispatch(setSorting(newSorting));
            dispatch(userApi.fetchAll( {page: p, term: term, sorting: newSorting} ));
        }
    }

    useEffect(() => {
        setPage(0);
        loadMoreUsers(0);
    }, [dispatch, term, firstNameSort, lastNameSort, emailSort]);

    useEffect( () => {
        if(users.length > 0 && showMoreUsers) setPage(page+1);
        setLoading(false);
    }, [users])

    return (
        <Card>
            <CardBody>
                <div style={{height: 'calc(100vh - 276px)', overflow: 'auto'}}>
                    <InfiniteScroll
                        element="div"
                        loadMore={ () => { loadMoreUsers(page); }}
                        hasMore={showMoreUsers}
                        loader={<div className="loader" key={0}>Loading ...</div>}
                        initialLoad={false}
                        useWindow={false}
                    >
                        <Table responsive hover >
                            <thead>
                                <tr>
                                    <th>Role</th>
                                    <SortableThead dir={firstNameSort} onSortChange={(dir) => { setFirstNameSort(dir) }}>First Name</SortableThead>
                                    <SortableThead dir={lastNameSort} onSortChange={(dir) => { setLastNameSort(dir) }}>Last Name</SortableThead>
                                    <SortableThead dir={emailSort} onSortChange={(dir) => { setEmailSort(dir) }}>Email</SortableThead>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((user) => (
                                    <UserListItem user={user} key={user.id} />
                                ))}
                            </tbody>
                        </Table>
                    </InfiniteScroll>
                </div>
            </CardBody>
        </Card>
    );
}

export default UsersList;
